<template>
    <el-table :data="data" style="width: 100%">
      <el-table-column
        v-for="(col, index) in columns"
        :key="index"
        :prop="col.prop"
        :label="col.label"
      ></el-table-column>
    </el-table>
  </template>
  
  <script>
  export default {
    props: {
      columns: {
        type: Array,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped>
  </style>
  